import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withLocalize, Translate } from 'react-localize-redux';
import { writeErr } from '../../common/logger';
import { isNullOrUndefined } from '../../../store/storeFunctions';

class RepiSearchManagerTooltip extends React.Component {
    shouldDisplay = false; // Temporarily disable this feature

    constructor(props){
        super(props);
        this.iconRef = React.createRef();
        this.state = { expanded: false };
    }

    render() {
        if (!this.shouldDisplay)
            return null;

        let left = 0;
        if (!isNullOrUndefined(this.iconRef) && !isNullOrUndefined(this.iconRef.current)) {
            try {
                let x = 0;
                const rect = this.iconRef.current.getBoundingClientRect();
                if (!isNullOrUndefined(rect)) {
                    const tmp = parseInt(Math.ceil(rect.x));
                    x = !isNaN(tmp) ? tmp : 0;
                }
                left = x + this.iconRef.current.offsetWidth;
            } catch {
                left = null;
                writeErr("Failed to calculate 'left' value");
            }
        }

        return (
            <>
                <div id={this.props.id} style={{ cursor: "pointer" }} onClick={this.handleClickInside} ref={this.iconRef}>
                    <FontAwesomeIcon icon="question-circle" />
                </div>
                {this.state.expanded && !isNullOrUndefined(left) && <div
                    className="tooltip show bs-tooltip-left"
                    style={{ position: "absolute", left: `calc(${left}px - 4em)` }}
                >
                    <div className="tooltip-inner" style={{ whiteSpace: "nowrap", maxWidth: "initial" }}>
                        <Translate id={this.props.trKey} />
                    </div>
                </div>}
            </>
        );
    }

    componentDidMount() {
        document.addEventListener("mouseup", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mouseup", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (isNullOrUndefined(this.props.id) || this.props.id !== event.target.id) {
            if (this.state.expanded)
                this.setState({ expanded: false });
        }
    }

    handleClickInside = (event) => {
        event.stopPropagation();
        if (!this.state.expanded)
            this.setState({ expanded: true });
    }
}

export default withLocalize(RepiSearchManagerTooltip);